import artifact from '$houdini/artifacts/SetPrintJobStatus'
import { MutationStore } from '../runtime/stores/mutation'

export class SetPrintJobStatusStore extends MutationStore {
	constructor() {
		super({
			artifact,
		})
	}
}
